<template>
  <div class="UpgradeToGold">
    <div class="subscriptions-block">
      <div class="subscriptions-title">
        <div class="icon-top-1">
          <img class="my-sub-icon" src="../../../assets/img/svg/my-sub.svg" />
        </div>
        <div class="top-title-1">My Subscriptions</div>
      </div>
      <div class="subscriptions-content mt-5">
        <v-row>
          <v-col cols="11">
            <div>
              <div class="username-sub">Hi {{ user.name }}</div>
              <div class="sub-title-sub">Your active subscriptions are:</div>
              <div class="trial-row">
                <div class="trial-col">
                  <ul>
                    <li v-if="!filteredSubscriptions || !filteredSubscriptions.length">
                      {{'No active subscription'}}
                    </li>
                    <li
                      v-for="(item,index) in filteredSubscriptions"
                      v-if="index % 2 === 0 && (item.is_purchased ||  item.is_subscribed || item.institute_purchased)"
                    >
                    {{item.length == 0 ? 'No active subscription': ''}}
                      {{ getDisplayName(item) ==="Boost Up" ? '' : getDisplayName(item) }}
                      {{ getDisplayName(item) !="Boost Up" &&item.product_name.length ?' - ' + getFilteredProductNames(item) : ''}}
                      <span class="expiry-date-span">{{ getExpiryText(item) }}</span>
                    </li>
                  </ul>
                </div>
                <div class="trial-col-divider"></div>
                <div class="trial-col">
                  <ul>
                    <li
                      v-for="(item, index) in filteredSubscriptions"
                      v-if="index % 2 !== 0 && (item.is_purchased ||  item.is_subscribed || item.institute_purchased)"
                    >
                      {{ getDisplayName(item) }}{{ item.product_name.length ? ' - ' + getFilteredProductNames(item) : ''}}
                      <span class="expiry-date-span">{{ getExpiryText(item) }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";

//import Subscription from "@/views/pages/Subscription/Subscription.vue";
//import PackagesList from "@/components/student/UpgradeToGold/PackagesList.vue";
export default {
  name: "MySubscription",
  components: {
    //PackagesList,
    //Subscription
  },
  mounted() {},
  methods: {
    getDisplayName(item) {
      if (item.name === "MASTERPYQPREMIUM") {
        return "Master PYQs";
      } else if (item.name === "PYQ") {
        return "Practice PYQs";
      }
      return item.name;
    },
    expiryDate(expiryDate) {
      return expiryDate
        ? "- valid up to " + moment(expiryDate).format("DD-MMM-YYYY")
        : "";
    },
    getExpiryText(item) {
      if (item.institute_purchased && !item.is_subscribed) {
        return "";
      }
      
      if (item.name === "Boost Up") {
        const batchId = this.user.batch_name || this.user.batch_id;
        if (batchId === "2026" || batchId === 2026) {
          return "Valid up to: 31-May-26";
        } else if (batchId === "2027" || batchId === 2027) {
          return "Valid up to: 31-May-27";
        } else if (batchId === "2028" || batchId === 2028) {
          return "Valid up to: 31-May-28";
        }
      }

      return this.expiryDate(item.expiry_date);
    },
      getProductName(item) {
      if (item.name === "Boost Up") {
        const batchId = this.user.batch_name || this.user.batch_id;
        if (batchId === "2026" || batchId === 2026) {
          return "Valid up to: 31-May-26";
        } else if (batchId === "2027" || batchId === 2027) {
          return "Valid up to: 31-May-27";
        } else if (batchId === "2028" || batchId === 2028) {
          return "Valid up to: 31-May-28";
        }
      }
      
      return this.expiryDate(item.expiry_date);
    },
    getFilteredProductNames(item) {
      if (!item.product_name || !item.product_name.length) return '';
      
      const mappedNames = item.product_name.map(productName => {
        if (item.name === "PYQ") {
          if (this.user.center_name === 'Medical' || this.user.center_name === 'NEET') {
            return "NEET";
          } else {
            return "JEE, ADVANCED";
          }
        }
        if (item.name === "AITS") {
          if (item.product_id.includes(25)) {
            return "MAIN";
          } else {
            return productName;
          }
        }
        return productName;
      });
      
      // Remove duplicates and join
      return [...new Set(mappedNames)].join(", ");
    },
  },
  computed: {
    ...mapState("userStore", ["user"]),
    filteredSubscriptions() {
      if (!this.user.subscription_details) return [];
      
      const filtered = this.user.subscription_details.filter(item => 
        item.name !== "PROFICIENCY" && 
        (item.is_purchased || item.is_subscribed || item.institute_purchased)
      );
      
      const hasBoostUp = filtered.some(item => item.name === "Boost Up");
      
      if (!hasBoostUp && this.user.institute === constants.ONLINE_INSTITUTE_ID) {
        const boostUpItem = {
          name: "Boost Up",
          is_purchased: 1,
          is_subscribed: 0,
          institute_purchased: 0,
          product_name: [],
          expiry_date: null
        };
        filtered.unshift(boostUpItem); 
      }
      
      const hasMasterPYQ = filtered.some(item => item.name === "MASTERPYQPREMIUM");
      
      if (hasMasterPYQ) {
        return filtered.filter(item => item.name !== "PYQ");
      }

      return filtered;
    },
  },
};
</script>
